import React, { useCallback, useEffect, useRef, useState } from 'react'
import CallApi from '../../data/CallApi';
import { useParams } from 'react-router-dom';
import { useProveedorCompany } from '../providers/ProveedorCompany';
import { toast } from 'react-toastify';
import { debounce } from 'lodash';

export const ModalSearchProductVC = ({
    addedProducts = [],
    setAddProduct = (() => { }),
    clientSelected = false,
}) => {
    const { sub_direc } = useParams();
    const { shortListProducts, setShortListProducts, currentBranch, returnCurrency } = useProveedorCompany();
    const currentListProduct = useRef([]);
    const itemListResults = useRef(null);
    const [listFiltered, setListFiltered] = useState([]);
    const [stateResults, setStateResults] = useState(false);

    const load_products = async () => {
        const { key_branch } = currentBranch ?? {};
        if (!key_branch) return;

        const itsSale = sub_direc === 'realizar';
        // console.log(`Sucursal:${key_branch}\nDireccion:${sub_direc}`);
        const getLPB = shortListProducts?.[key_branch]?.[sub_direc]; //Lista de productos por sucursal
        let getShortList;

        if (!getLPB || (getLPB ?? []).length == 0) {
            const fetchProductList = await CallApi({
                url: `api/company/product/short-list?key_branch=${key_branch}${!itsSale ? '&type=all' : ''}`
            });

            getShortList = (fetchProductList ?? []).map((data) => ({
                id: data.key_product,
                codigo: data.code_product,
                nombre: data.fullName,
                precio1: data.price1,
                precio2: data.price2,
                precio3: data.price3,
                noprice: data.wholesale_price,
                stock: itsSale ? data.stock : 9999,
                img_product: data.img_product,
            }));
        } else {
            getShortList = getLPB;
        }

        currentListProduct.current = getShortList;
        setListFiltered(getShortList);
        setShortListProducts((current_list) => ({
            ...current_list,
            [key_branch]: {
                ...(current_list?.[key_branch] ?? {}),
                [sub_direc]: getShortList
            }
        }));
    };

    const filterProducts = useCallback(
        debounce(async (event) => {
            var excludedIds = addedProducts.map((p) => p.id);

            const value_search = String(event.target.value).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

            if (value_search.trim().length >= 1) {
                const results = currentListProduct.current.filter((product) => {
                    const matchText =
                        product.codigo.toLowerCase().includes(value_search.toLowerCase()) ||
                        product.nombre.toLowerCase().includes(value_search.toLowerCase());
                    const notExcluded = !excludedIds.includes(product.id);
                    return matchText && notExcluded;
                });
                setListFiltered(results);
            } else {
                setListFiltered([]);
            }
        }, 700),
        [currentBranch]
    );

    const addProduct_Order = (product) => {
        const get_list = document.getElementsByName("price-" + product.id);
        for (const element of get_list) {
            if (element.checked) {
                product.chosenPrice = element.value;
                break;
            }
        }

        setListFiltered((prev) => prev.filter((item) => item.id !== product.id));
        setAddProduct((current_list) => ([...current_list, {
            id: product.id,
            codigo: product.codigo,
            nombre: product.nombre,
            precio: clientSelected?.user_disc != null ? product.noprice : product.chosenPrice,
            img_product: product.img_product,
            retailPrice: product.chosenPrice,
            wholesalerPrice: product.noprice,
            stock: product.stock,
            cantidad: 1, // cantidad inicial
            descuento: product.descuento || 0,
        }]));
    };

    function handleViewResults(active = false) {
        if (itemListResults.current) {
            itemListResults.current.style.display = active ? 'flex' : 'none';
            setStateResults(active);
        }
    }

    useEffect(() => {
        if (['realizar', 'cotizar'].includes(sub_direc)) load_products();
        else return toast.error('Sub Direccion invalida');
    }, [currentBranch, sub_direc])

    return (
        <>
            <div className="search-container" style={{ flex: "0 1 550px", position: "relative", overflow: 'visible' }}>
                <input
                    id="input-search"
                    type="text"
                    className="search-input"
                    placeholder="Buscar por código o nombre..."
                    onChange={filterProducts}
                    style={{ position: 'relative', zIndex: 3 }}
                    onClick={() => handleViewResults(true)}
                    disabled={!clientSelected}
                    autoComplete='off'
                />

                <ul
                    ref={itemListResults}
                    style={{
                        display: "none",
                        position: "absolute",
                        background: "#fff",
                        zIndex: 3,
                        height: "auto",
                        maxHeight: "70vh",
                        gap: '0px',
                        top: '48px',
                        left: '0px',
                    }}>
                    {listFiltered.map((product) => {
                        return (
                            <li
                                key={product.id}
                                className="search-result-item-product"
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    padding: "10px",
                                    borderBottom: "1px solid #ccc",
                                    justifyContent: "space-between",
                                    background: "#f3f3f6",
                                }}>
                                {/* Columna izquierda: Código, Nombre, Stock */}
                                <div style={{ width: "45%" }}>
                                    <div>
                                        <strong>Código:</strong> {product.codigo}
                                    </div>
                                    <div>
                                        <strong>Nombre:</strong> {product.nombre}
                                    </div>
                                    <div>
                                        <strong>Stock:</strong> {product.stock}
                                    </div>
                                </div>

                                {/* Columna derecha: Selección de precios + botón Agregar */}
                                <div style={{ width: "50%", display: "flex", flexDirection: "column" }}>
                                    {/* <label style={{ fontWeight: 'bold', marginBottom: '4px' }}>Selecciona un precio:</label> */}

                                    {/* Precio 1 */}
                                    <label style={{ marginTop: "0px" }}>
                                        <input
                                            type="radio"
                                            name={`price-${product.id}`}
                                            value={product.precio1}
                                            disabled={product.precio1 === 0}
                                            defaultChecked={true}
                                        />{" "}
                                        Precio 1: {returnCurrency(product.precio1)}
                                    </label>

                                    {/* Precio 2 (si existe) */}
                                    {product.precio2 > 0 && (
                                        <label style={{ marginTop: "0px" }}>
                                            <input
                                                type="radio"
                                                name={`price-${product.id}`}
                                                value={product.precio2}
                                            />{" "}
                                            Precio 2: {returnCurrency(product.precio2)}
                                        </label>
                                    )}

                                    {/* Precio 3 (si existe) */}
                                    {product.precio3 > 0 && (
                                        <label style={{ marginTop: "0px" }}>
                                            <input
                                                type="radio"
                                                name={`price-${product.id}`}
                                                value={product.precio3}
                                            />{" "}
                                            Precio 3: {returnCurrency(product.precio3)}
                                        </label>
                                    )}

                                    <button
                                        className="btn-add-product"
                                        style={{
                                            alignSelf: "flex-end",
                                            marginTop: "8px",
                                            padding: "6px 12px",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => addProduct_Order(product)}>
                                        Agregar
                                    </button>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>

            {
                stateResults && (
                    <div style={{ position: 'fixed', top: 0, left: 0, height: '100vh', width: '100%', backgroundColor: 'transparent', zIndex: 2 }} onClick={() => handleViewResults(false)}>
                    </div>
                )
            }
        </>
    )
}
